'use strict';

let instance = null;

export default class HttpService {

    constructor() {
        if (!instance) {
            this.baseUrl = '/api/Api.svc';
            this.request = new XMLHttpRequest();
        }
        return instance;
    };

    getData(url) {
        return new Promise((resolve, reject) => {
            this.request.onreadystatechange = () => {
                if (this.request.readyState === 4) {
                    if (this.request.status === 200)
                        resolve(JSON.parse(this.request.responseText));
                    else
                        reject(this.request.responseText);
                }
            }
            this.request.open('GET', this.baseUrl + url);
            this.request.send();
        });
    };

    getInfoForPopupPointOnMap(latLng, oid) {
        return new Promise((resolve, reject) => {
            this.getData('/GetInfoForPopupPointOnMap?lat=' + latLng.lat + '&lon=' + latLng.lng + '&oid=' + oid)
                .then(
                    data => {
                        resolve(data);
                    },
                    error => {
                        //РЅР°РїРёСЃР°С‚СЊ РѕР±СЂР°Р±РѕС‚С‡РёРє РѕС€РёР±РєРё
                    }
                );
        });
    }
}
